import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDialogDirective } from './directives/confirmDialog.directive';
import { ConfirmDialogComponent } from './components/confirm.dialog.component';
import { MatDialogModule } from '@angular/material/dialog';


@NgModule({
	imports: [
		CommonModule,
		MatDialogModule
	],
	declarations: [
		ConfirmDialogDirective,
		ConfirmDialogComponent,
	],
	exports: [
		ConfirmDialogDirective,
		ConfirmDialogComponent,
	],
})
export class ConfirmDialogModule {
}
